import { render } from "./Integrations.vue?vue&type=template&id=3d8c33d8"
import script from "./Integrations.vue?vue&type=script&lang=ts"
export * from "./Integrations.vue?vue&type=script&lang=ts"

import "./Integrations.vue?vue&type=style&index=0&id=3d8c33d8&lang=scss"
script.render = render

export default script